import { useCallback, useMemo } from 'react';

import { type SortType } from '@hivebrite/design-system/Table';

import { useParsedQueryParams } from 'hb-react/shared/hooks/useParsedQueryParams';
import { paramTypesForPagination } from 'hb-react/shared/hooks/useParsedQueryParams/utils/paramTypesForPagination';

export const useQueryParamsForPagination = ({
  defaultPageSize,
}: {
  defaultPageSize: number;
}) => {
  const paginationParamTypes = useMemo(
    () =>
      paramTypesForPagination({
        defaultPageSize,
      }),
    [defaultPageSize],
  );

  const {
    parsedParams: pagination,
    clearParams: clearPagination,
    updateParam: updatePagination,
    updaters: { updatePage, updateSortBy, updateOrder },
  } = useParsedQueryParams({
    paramTypes: paginationParamTypes,
  });

  const handleSort = useCallback(
    (key: string, order: SortType) => {
      updateSortBy(key);
      updateOrder(order);
    },
    [updateSortBy, updateOrder],
  );

  return {
    pagination,
    clearPagination,
    updatePage,
    updatePagination,
    updateSortBy,
    updateOrder,
    handleSort,
  };
};
